'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _report = require('selectors/report');

var _report2 = require('redux/modules/report');

var reportActions = _interopRequireWildcard(_report2);

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('../ProjectReport/ProjectReport.scss');

var ProjectRecipientReport = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        _ref$params = _ref.params,
        projectId = _ref$params.projectId,
        recipientId = _ref$params.recipientId;
    return (0, _asyncPromise2.default)(dispatch(reportActions.loadRecipientReport({ projectId: projectId, recipientId: recipientId })).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    projectType: ownProps.params.type,
    projectId: Number(ownProps.params.projectId),
    reportData: (0, _report.getRecipientReportData)(state),
    reportLoading: state.report.recipientReportLoading
  };
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectRecipientReport, _Component);

  function ProjectRecipientReport() {
    (0, _classCallCheck3.default)(this, ProjectRecipientReport);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectRecipientReport.__proto__ || (0, _getPrototypeOf2.default)(ProjectRecipientReport)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectRecipientReport, [{
    key: 'getBackUrl',
    value: function getBackUrl() {
      var _props = this.props,
          projectType = _props.projectType,
          projectId = _props.projectId;

      return '/projects/' + projectType + '/' + projectId + '/report';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          reportData = _props2.reportData,
          reportLoading = _props2.reportLoading,
          t = _props2.t;


      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Project Recipient Report' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(_components.BackButton, { asBlock: true, backUrl: this.getBackUrl() }),
          reportLoading ? _react2.default.createElement(_components.Loader, { className: 'margin-top-20' }) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'section',
              { className: styles.section },
              _react2.default.createElement(
                'h3',
                null,
                t('File info')
              ),
              _react2.default.createElement(_components.ProjectRecipientReportInformation, { reportData: reportData })
            ),
            _react2.default.createElement(
              'section',
              { className: styles.section },
              _react2.default.createElement(
                'h3',
                null,
                t('Detailed actions')
              ),
              _react2.default.createElement(_components.ProjectRecipientReportDetailed, { reportData: reportData })
            )
          )
        )
      );
    }
  }]);
  return ProjectRecipientReport;
}(_react.Component), _class2.propTypes = {
  projectId: _propTypes2.default.number,
  projectType: _propTypes2.default.string,
  reportData: _propTypes2.default.object,
  reportLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp)) || _class) || _class) || _class);
exports.default = ProjectRecipientReport;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProjectRecipientReport/ProjectRecipientReport.js
// module id = 2203
// module chunks = 1